<template>
    <div>
        <base-crud
                crudName="Tipos de Não Conformidades"
                newText="Novo Tipo de Não Conformidade"
                :table="nonconformityTypeTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="true"
                :enableEdit="true"
                :enableDelete="true"
                :enableView="false"
        >
        </base-crud>
    </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data: function() {
    return {
      nonconformityTypeTable: "nonconformityTypeTable",
      teams: [],
      pages: [],
      url: "",
      columns: ["id", "name", "actions"],
      tableData: ["id", "name"],
      options: {
        filterable:["id", "name"],
        filterByColumn: true,                   
        sortable: ["id", "name"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          name: "Nome",
          actions: "Ações"
        },
        requestFunction: function(data) {
          let requestData = {};

           let query = this.$parent.$parent.query(data.query);
           requestData.params = data;
           requestData.params.query = "";
           requestData.params.with = [];

          return this.$http
              .get(this.url + '?' + query, requestData)
              .catch(
                  function(e) {
                      this.dispatch("error", e);
                  }.bind(this)
              );
        }
      },
      endPoint: "nonconformity-types/"
    };
  },
  methods: {
    query: function (query) {
      let columns = {
        id: 'id',
        name: 'name',
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });

      return filters;
    }
  },
  components: {
    BaseCrud
  }
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/NonconformityType/Crud.vue